import { render, staticRenderFns } from "./TabsMobile.vue?vue&type=template&id=0896f0a4&scoped=true&lang=pug&"
import script from "./TabsMobile.vue?vue&type=script&lang=js&"
export * from "./TabsMobile.vue?vue&type=script&lang=js&"
import style0 from "./TabsMobile.vue?vue&type=style&index=0&id=0896f0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0896f0a4",
  null
  
)

export default component.exports